import { render } from "./Timer.vue?vue&type=template&id=a772fbbc"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./Timer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script